(function () {
  "use strict";

  function forceCollectionFilterDrawerFromRight() {
    var FacetDrawer = customElements.get("facet-drawer");

    if (!FacetDrawer || FacetDrawer.prototype.__charlotteRightPatch) {
      return;
    }

    var parentPrototype = Object.getPrototypeOf(FacetDrawer.prototype);
    var nativeOpenFrom = Object.getOwnPropertyDescriptor(parentPrototype, "openFrom");

    Object.defineProperty(FacetDrawer.prototype, "openFrom", {
      configurable: true,
      get: function () {
        if (this.classList.contains("charlotte-collection-filter-drawer")) {
          return "right";
        }

        return nativeOpenFrom && nativeOpenFrom.get ? nativeOpenFrom.get.call(this) : this.getAttribute("open-from") || "right";
      }
    });

    FacetDrawer.prototype.__charlotteRightPatch = true;
  }

  if (customElements.get("facet-drawer")) {
    forceCollectionFilterDrawerFromRight();
  } else {
    customElements.whenDefined("facet-drawer").then(forceCollectionFilterDrawerFromRight);
  }

  document.addEventListener("click", function (event) {
    var clearButton = event.target.closest("[data-charlotte-filter-clear]");

    if (!clearButton) {
      return;
    }

    var drawer = clearButton.closest(".charlotte-collection-filter-drawer");
    var form = drawer && drawer.querySelector("#facet-form");

    if (!drawer || !form) {
      return;
    }

    event.preventDefault();

    form.querySelectorAll('input[name^="filter."]').forEach(function (input) {
      if (input.type === "checkbox" || input.type === "radio") {
        input.checked = false;
      } else {
        input.value = "";
      }
    });

    form.querySelectorAll('input[name="sort_by"]').forEach(function (input) {
      input.checked = false;
    });

    form._isDirty = true;

    if (HTMLFormElement.prototype.requestSubmit) {
      form.requestSubmit();
    } else {
      form.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
    }

    if (typeof drawer.hide === "function") {
      drawer.hide();
    }
  });
})();
